export enum ListItemTypeEnum {
    Simple = 'simple',
    Icon = 'icon',
    SmallPreview = 'smallPreview',
    LargePreview = 'largePreview',
    FullPage = 'fullPage',
}
